import React from 'react';
import { Link } from 'react-router-dom';
import { ReactComponent as Logo } from '../../Assets/images/HeaderImages/Logo.svg';

const updateCurrentDirectoryPrivacyPolicy = (e) => {
  var currentPage = document.getElementById("currentPage");
  currentPage.textContent =  "_ privacy policy";
  window.scrollTo({
    top: 0,
    left: 0,
    behavior: 'smooth'
  });
};

const updateCurrentDirectoryTermsAndConditions = (e) => {
  var currentPage = document.getElementById("currentPage");
  currentPage.textContent =  "_ terms and conditions";
  window.scrollTo({
    top: 0,
    left: 0,
    behavior: 'smooth'
  });
};

const updateCurrentDirectoryWeb = (e) => {
  var currentPage = document.getElementById("currentPage");
  currentPage.textContent =  "_ web dev UX/UI";
  window.scrollTo({
    top: 0,
    left: 0,
    behavior: 'smooth'
  });
};

const updateCurrentDirectoryArt = (e) => {
  var currentPage = document.getElementById("currentPage");
  currentPage.textContent =  "_ art";
  window.scrollTo({
    top: 0,
    left: 0,
    behavior: 'smooth'
  });
};

const updateCurrentDirectoryAvailable = (e) => {
  var currentPage = document.getElementById("currentPage");
  currentPage.textContent =  "_ available art";
  window.scrollTo({
    top: 0,
    left: 0,
    behavior: 'smooth'
  });
};

const updateCurrentDirectoryContact = (e) => {
  var currentPage = document.getElementById("currentPage");
  currentPage.textContent =  "_ contact & social";
  window.scrollTo({
    top: 0,
    left: 0,
    behavior: 'smooth'
  });
};

function Footer() {   
    let currentYear = new Date().getFullYear();  
    return (
      <footer>
        <Logo />
          <p className="footer-pages">
            <span><Link to="/privacy-policy/" title="Link to Privacy Policy Page" onClick={updateCurrentDirectoryPrivacyPolicy}>Privacy Policy</Link></span>|
            <span><Link to="/terms-and-conditions/" title="Link to Terms and Conditions Page" onClick={updateCurrentDirectoryTermsAndConditions}>Terms and Conditions</Link></span>|
            <span><Link to="/web-development-ux-ui/" title="Link to web development page" onClick={updateCurrentDirectoryWeb}>Web Development</Link></span>|
            <span><Link to="/art-gallery-portfolio/" title="Link to past and present artwork portfolio" onClick={updateCurrentDirectoryArt}>Art</Link></span>|
            <span><Link to="/available-art-gallery/" title="Link to available art for sale" onClick={updateCurrentDirectoryAvailable}>Available Art</Link></span>|
            <span><Link to="/contact/" title="Link to contact me page" onClick={updateCurrentDirectoryContact}>Contact</Link></span>
          </p>

          <div className="footer-address">
            <p>VCASSO LLC<br />
            10056 W Unser Dr, Unit 301<br />
            Littleton CO, 80127</p>
          </div>

          <p><small>Copyright &copy; { currentYear.toString() } Vanja Borcic. All rights reserved.</small></p>
          <p><small>All images on this website are original, created by, and property of Vanja Borcic.</small></p>
      </footer>
    );
  }
  
  export default Footer;